import { render, staticRenderFns } from "./TestimonialItem.vue?vue&type=template&id=ca5d8a06&"
import script from "./TestimonialItem.vue?vue&type=script&lang=ts&"
export * from "./TestimonialItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports